import { Injectable } from '@angular/core';
import { IApiBackendRouteService } from '../abstract/api-routes.service';
import { API_BASE_URL } from '../../../core/providers/constants/api.constants';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ApiRouteInspectionStageService extends IApiBackendRouteService {
  constructor(protected readonly http: HttpClient) {
    super();
  }
  protected urlRoute = `${API_BASE_URL}/inspection/stage`;

  all(): Observable<{ id: number; title: string }[]> {
    return this.http.get<{ id: number; title: string }[]>(`${this.urlRoute}`);
  }
}
